const config = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  recaptcha_key: process.env.REACT_APP_RECAPTCHA_KEY,
  socketServerPath: process.env.REACT_APP_SOCKET_SERVER_PATH,
  socketPath: process.env.REACT_APP_SOCKET_PATH,
  stripePublishableKey: process.env.REACT_APP_PUBLISHABLE_KEY,
};

export default config;
